import { connect } from 'react-redux';
import { IReduxRootState } from '../app/reduxRootState.interface';
import Tiles from './Tiles';
import { TextHelpers } from '../utils/textHelpers';
import * as webStorage from '@com.rakuten.esd/myr-web-storage';

export function mapStateToProps(state: IReduxRootState) {
    const clientConfigEmpty = Object.keys(state.app.clientConfig).length === 0;
    const appConfigEmpty = Object.keys(state.app.appConfig).length === 0;
    const loading = clientConfigEmpty || appConfigEmpty || state.app.redirect;
    const loggingIn = state.authentication.loggingIn ?? true;
    const currentLanguage = state.app.locale;
    const { myDataUrl } = state.app.clientConfig;
    const targetUrl = TextHelpers.replaceMyDataLang(myDataUrl ?? '', currentLanguage);
    const hasEKYC = state.member.hasEKYC ?? false;
    const hasSocialLink = state.member.hasSocialLink ?? false;
    const showExternalBankLink = state.app.presentationConfig.showSections.externalBankLink
        ? state.app.presentationConfig.showSections.externalBankLink
        : '';
    const isShowSignOut = state.app.presentationConfig.showSections.signout ?? true;
    const stateQueryParam = webStorage.getState();
    const locale = state.app.locale;
    let returnUrl = '/';
    let returnUrlText = '';
    if (!loading) {
        returnUrl = `${state.app.clientConfig.returnUrl}${
            stateQueryParam ? `?state=${stateQueryParam}` : ''
        }`;
        returnUrlText = state.app.clientConfig.returnUrlText
            ? TextHelpers.returnUrlTextConfigHandle(state.app.clientConfig.returnUrlText, locale)
            : returnUrl.replace(/(^http(s)?:\/\/)|(\?.*$)/g, '');
    }
    return {
        clientConfig: state.app.clientConfig,
        currentLanguage,
        hasEKYC,
        hasSocialLink,
        loading: loggingIn || loading,
        presentationConfig: state.app.presentationConfig,
        routes: state.routes,
        showExternalBankLink,
        targetUrl,
        user: state.member,
        isShowSignOut,
        returnUrl,
        returnUrlText,
    };
}

const TilesContainer = connect(mapStateToProps)(Tiles);

export default TilesContainer;
